import {useContext} from 'react'

import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'

const BASE_CLASS_NAME = 'mt-FormC2bVehicle-InputAddonPlate'

const InstantOfferLandingInputAddonPlate = () => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')

  return (
    <div className={BASE_CLASS_NAME}>
      <div className={`${BASE_CLASS_NAME}ImageWrapper`}>
        <AtomImage
          aria-hidden="true"
          className={`${BASE_CLASS_NAME}Image`}
          role="presentation"
          src={`${URL_STATICS_IMAGES}common/plates/spanish-registration-plate.svg`}
        />
      </div>
    </div>
  )
}

InstantOfferLandingInputAddonPlate.displayName = 'InstantOfferLandingInputAddonPlate'

export default InstantOfferLandingInputAddonPlate
